import _ from "lodash";
import React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import { CareerCenterEducationTypes } from "../../../../domain";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";

interface OwnProps {
    formComponent: Comp.Validation.IComponentWithValidatedForm;
    label?: string;
    name: string;
}

interface OwnState {
}

export class EducationEditor extends React.Component<OwnProps, OwnState> {
    public render() {
        const modelItems = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>().data.education;

        const educationTypes: M.Editors.SelectItem[] = _.orderBy(CareerCenterEducationTypes.Values, "sort")
            .map((t) => {
                return {
                    id: t.id,
                    render: t.name,
                    selected: false,
                };
            });

        // Build link editors
        const sortedItems = _.orderBy(modelItems, "index");
        const items = sortedItems.map((item, i) => {
            return <li key={i} className="list-builder-item" style={{ display: item.isDelete ? "none" : "block" }}>
                <div className="list-builder-fields">
                    <Comp.Editors.DropdownField
                        formComponent={this.props.formComponent}
                        items={educationTypes}
                        name={this.props.name + `[${i}].typeId`}
                        placeholder="Select..."
                        placeholderValue={0}
                    />

                    <Comp.Editors.TextField
                        formComponent={this.props.formComponent}
                        name={this.props.name + `[${i}].organization`}
                    />

                    <Comp.Editors.MonthPickerField
                        format="MM/YYYY"
                        formComponent={this.props.formComponent}
                        name={this.props.name + `[${i}].completedOn`}
                        placeholder="mm / yyyy"
                        reverseYears
                        yearRange={[1950, 2020]}
                    />
                </div>
                <BS.Button bsStyle="danger" className="remove-trigger" onClick={() => this.onDelete(item.index)} title="Delete education">
                    <i className="fa fa-times"></i>
                </BS.Button>
            </li>;
        });

        return <div>
            <Comp.Editors.FormField label="" name={this.props.name} noFieldWrap>
                <ul className="list-builder">
                    {items}
                </ul>
            </Comp.Editors.FormField>

            <Comp.Editors.FormField name="">
                <BS.ButtonGroup>
                    <BS.Button onClick={() => this.onAdd()}><i className="fa fa-plus"></i> Add education</BS.Button>
                </BS.ButtonGroup>
            </Comp.Editors.FormField>
        </div>;
    }

    private onAdd() {
        const formModel = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>();
        formModel.data.education.push({
            ...Forms.CareerCenter.DefaultPostResumeObjects.Education(),
            index: formModel.data.education.length,
        });
        this.props.formComponent.updateFormModel(formModel);
    }

    private onDelete(slideIdx: number) {
        const formModel = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>();
        const item = _.find(formModel.data.education, (s, i) => s.index === slideIdx);

        if (item)
            item.isDelete = true;

        this.props.formComponent.updateFormModel(formModel);
    }
}



// WEBPACK FOOTER //
// ./src/containers/careerCenter/postResume/components/EducationEditor.tsx